app.service("DicomWorklistAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		var service = {
			// Checked against PATIENT_DICOM_WORKLIST_SEND; the WALK-IN link is hidden from anyone without it.
			createWorklistEntry: function (patientId, payload) {
				return $http({
					method: "POST",
					url: ENV.API + `/api/dicom/worklist`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: payload,
				});
			},
		};
		return service;
	},
]);
